import { useLayoutEffect } from 'react';
import { Metrics } from './metrics';
import { StrictMode } from 'react';
import { render } from 'react-dom';
import { createRoot } from 'react-dom/client';
// @ts-expect-error untyped loader
import { name as packageName } from 'current-package-loader!';
import { jsx as _jsx } from "react/jsx-runtime";
// Supports User Timing and Performance Timeline APIs that we use to measure performance
const canUsePerfAPIs = typeof performance !== 'undefined' && ['mark', 'measure', 'getEntriesByName'].every(method => typeof performance[method] === 'function');
export function Root({
  children
}) {
  useLayoutEffect(() => {
    if (canUsePerfAPIs) {
      performance.mark('quartz.afterRootRender');

      // `performance.mark()` doesn't return a performance `PerformanceMark` in some browsers, so we use `getEntriesByName`
      // See: https://developer.mozilla.org/en-US/docs/Web/API/Performance/mark#browser_compatibility
      performance.getEntriesByName('quartz.beforeRootRender', 'mark').forEach(entry => {
        Metrics.timer('beforeRootRender').update(entry.startTime);
      });
      try {
        performance.measure('quartz.rootRender', 'quartz.beforeRootRender', 'quartz.afterRootRender');
      } catch (_unused) {
        // `performance.measure()` can throw but shouldn't in our case
      }

      // `performance.measure()` doesn't return a performance `PerformanceMeasure` in some browsers, so we use `getEntriesByName`
      // See: https://developer.mozilla.org/en-US/docs/Web/API/Performance/measure#browser_compatibility
      performance.getEntriesByName('quartz.rootRender', 'measure').forEach(entry => {
        Metrics.timer('rootRender').update(entry.duration);
      });
    }
  }, []);
  return children;
}
function getLegacyRootLocalStorageOverride() {
  try {
    const value = localStorage.getItem('LEGACY_ROOT_OVERRIDE');
    const parsedValue = value !== null ? JSON.parse(value) : null;
    return typeof parsedValue === 'boolean' ? parsedValue : null;
  } catch (_unused2) {
    return null;
  }
}
export function renderRoot(reactElement, {
  strictMode = false,
  legacyRoot = true
} = {}) {
  const container = document.querySelector('.page');
  if (!container) {
    throw new Error('Invariant: Could not find container element');
  }
  const children = /*#__PURE__*/_jsx(Root, {
    children: strictMode ? /*#__PURE__*/_jsx(StrictMode, {
      children: reactElement
    }) : reactElement
  });
  if (canUsePerfAPIs) {
    performance.mark('quartz.beforeRootRender');
  }
  const legacyRootOverride = getLegacyRootLocalStorageOverride();
  if (legacyRootOverride !== null) {
    legacyRoot = legacyRootOverride;
  }
  if (!legacyRoot) {
    createRoot(container, {
      identifierPrefix: packageName
    }).render(children);
  } else {
    render(children, container);
  }
}